const img = require('./Upscale.png'); export default img;